import { render } from "./GDPRBlock.vue?vue&type=template&id=dffb3bee"
const script = {}

import "./GDPRBlock.vue?vue&type=style&index=0&id=dffb3bee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__